import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import Shell from '../components/ui/Shell';

export default function NotFoundPage() {
  return (
    <Shell centered maxWidth="narrow">
      <Card>
        <CardHeader>
          <CardTitle>Page not found</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground">
            The page you followed doesn't exist. If you are trying to join an
            interview, please open the link your recruiter shared.
          </p>
          <p className="text-sm">
            <Link
              to="/"
              className="text-primary underline-offset-2 hover:underline"
            >
              Go to the home page
            </Link>
          </p>
        </CardContent>
      </Card>
    </Shell>
  );
}
